
const offsetMinutos = (fecha, zona) => {
  const partes = new Intl.DateTimeFormat("en-US", {
    timeZone: zona,
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })
    .formatToParts(fecha)
    .reduce((acc, p) => ({ ...acc, [p.type]: p.value }), {});

  const hora = partes.hour === "24" ? 0 : Number(partes.hour);

  const comoSiFueraUTC = Date.UTC(
    Number(partes.year),
    Number(partes.month) - 1,
    Number(partes.day),
    hora,
    Number(partes.minute),
    Number(partes.second)
  );

  return Math.round((comoSiFueraUTC - fecha.getTime()) / 60000);
};

export const aInstante = (horaDePared, zona) => {
  if (!horaDePared) return null;

  const comoUTC = new Date(`${horaDePared.slice(0, 16)}:00Z`);
  if (Number.isNaN(comoUTC.getTime())) return null;

  if (!zona) return comoUTC;

  const primera = new Date(comoUTC.getTime() - offsetMinutos(comoUTC, zona) * 60000);
  const ajustado = offsetMinutos(primera, zona);

  return new Date(comoUTC.getTime() - ajustado * 60000);
};

export const aHoraDePared = (instante, zona) => {
  if (!instante) return "";

  const fecha = new Date(instante);
  if (Number.isNaN(fecha.getTime())) return "";

  const partes = new Intl.DateTimeFormat("en-CA", {
    timeZone: zona || undefined,
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  })
    .formatToParts(fecha)
    .reduce((acc, p) => ({ ...acc, [p.type]: p.value }), {});

  const hora = partes.hour === "24" ? "00" : partes.hour;

  return `${partes.year}-${partes.month}-${partes.day}T${hora}:${partes.minute}`;
};

export const zonaLocal = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

export const desfaseZona = (zona, referencia = new Date()) => {
  try {
    const min = offsetMinutos(referencia, zona);
    const signo = min >= 0 ? "+" : "-";
    const abs = Math.abs(min);
    const h = Math.floor(abs / 60);
    const m = abs % 60;
    return `GMT${signo}${h}${m ? `:${String(m).padStart(2, "0")}` : ""}`;
  } catch {
    return "";
  }
};

export const nombreZona = zona => {
  const encontrada = ZONAS.find(z => z.zona === zona);
  return encontrada
    ? encontrada.nombre
    : String(zona || "").split("/").pop().replace(/_/g, " ");
};

export const etiquetaZona = (zona, referencia = new Date()) => {
  const desfase = desfaseZona(zona, referencia);
  return desfase ? `${nombreZona(zona)} · ${desfase}` : nombreZona(zona);
};

const ZONAS = [
  { zona: "America/Guayaquil", nombre: "Ecuador" },
  { zona: "America/Bogota", nombre: "Colombia" },
  { zona: "America/Lima", nombre: "Perú" },
  { zona: "America/Caracas", nombre: "Venezuela" },
  { zona: "America/La_Paz", nombre: "Bolivia" },
  { zona: "America/Santiago", nombre: "Chile" },
  { zona: "America/Argentina/Buenos_Aires", nombre: "Argentina" },
  { zona: "America/Montevideo", nombre: "Uruguay" },
  { zona: "America/Asuncion", nombre: "Paraguay" },
  { zona: "America/Sao_Paulo", nombre: "Brasil (São Paulo)" },
  { zona: "America/Panama", nombre: "Panamá" },
  { zona: "America/Costa_Rica", nombre: "Costa Rica" },
  { zona: "America/Guatemala", nombre: "Guatemala" },
  { zona: "America/El_Salvador", nombre: "El Salvador" },
  { zona: "America/Tegucigalpa", nombre: "Honduras" },
  { zona: "America/Managua", nombre: "Nicaragua" },
  { zona: "America/Santo_Domingo", nombre: "Rep. Dominicana" },
  { zona: "America/Havana", nombre: "Cuba" },
  { zona: "America/Puerto_Rico", nombre: "Puerto Rico" },
  { zona: "America/Mexico_City", nombre: "México (Centro)" },
  { zona: "America/Tijuana", nombre: "México (Tijuana)" },
  { zona: "America/New_York", nombre: "EE.UU. — Este (Nueva York)" },
  { zona: "America/Chicago", nombre: "EE.UU. — Centro (Chicago)" },
  { zona: "America/Denver", nombre: "EE.UU. — Montaña (Denver)" },
  { zona: "America/Phoenix", nombre: "EE.UU. — Arizona" },
  { zona: "America/Los_Angeles", nombre: "EE.UU. — Pacífico (Los Ángeles)" },
  { zona: "America/Toronto", nombre: "Canadá — Toronto" },
  { zona: "America/Vancouver", nombre: "Canadá — Vancouver" },
  { zona: "UTC", nombre: "UTC" }
];

export const zonasDisponibles = () => {
  const propia = zonaLocal();

  if (ZONAS.some(z => z.zona === propia)) return ZONAS;

  return [{ zona: propia, nombre: "Tu zona" }, ...ZONAS];
};
